var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "channels" },
    [
      _c(
        "b-button-group",
        { staticClass: "float-right mt-3" },
        [
          _c("input-button", {
            attrs: {
              btnStyle: "link-style",
              pointable: "",
              variant: "plainText",
              inputPlaceholder: _vm.$t("Button.selectAll")
            },
            on: {
              click: function($event) {
                return _vm.selectAll()
              }
            }
          }),
          _vm._v(" "),
          _c("input-button", {
            attrs: {
              btnStyle: "link-style",
              pointable: "",
              variant: "plainText",
              inputPlaceholder: _vm.$t("Button.unselectAll")
            },
            on: {
              click: function($event) {
                return _vm.deselectAll()
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.getConnectedChannelNames, function(group) {
        return _c(
          "div",
          { key: group, staticClass: "channel-group container p-0 m-0" },
          [
            _c("div", { staticClass: "spacer-subsection d-none d-md-block" }),
            _vm._v(" "),
            _c("div", {
              staticClass: "spacer-subsection-smaller d-block d-md-none"
            }),
            _vm._v(" "),
            _c("h5", { staticClass: "channel-category-label" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t(_vm.expandName(group))) + "\n    "
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.getChannelParams(group).boards || [], function(board) {
              return _c("channel", {
                key: board.identity,
                ref: group + "_" + board.identity,
                refInFor: true,
                staticClass: "col m-0 p-0",
                attrs: {
                  label: _vm.getBoardLabel(board.type, board),
                  uuid: group + "_" + board.identity,
                  identity: board.identity,
                  connected: _vm.getChannelParams(group).connected,
                  channelName: group,
                  channelIcon: _vm.getChannelParams(group).icon,
                  selected: _vm.isSelected(board.identity)
                },
                on: {
                  channelSelected: _vm.channelSelected,
                  requestSchedualeEdit: _vm.requestSchedualeEdit
                }
              })
            })
          ],
          2
        )
      }),
      _vm._v(" "),
      _vm._l(_vm.getNotConnectedChannelNames, function(group) {
        return _c(
          "div",
          { key: group, staticClass: "channel-group container p-0 m-0" },
          [
            _c("div", { staticClass: "spacer-subsection d-none d-md-block" }),
            _vm._v(" "),
            _c("div", {
              staticClass: "spacer-subsection-smaller d-block d-md-none"
            }),
            _vm._v(" "),
            _c("h5", { staticClass: "channel-category-label" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t(_vm.expandName(group))) + "\n    "
              )
            ]),
            _vm._v(" "),
            _c("channel", {
              ref: group,
              refInFor: true,
              staticClass: "col m-0 p-0",
              attrs: {
                uuid: group,
                falseUnconnected: _vm.isFalseUnconnected(group),
                connected: _vm.getChannelParams(group).connected,
                channelName: group,
                channelIcon: _vm.getChannelParams(group).icon,
                selected: false
              },
              on: {
                channelSelected: _vm.channelSelected,
                requestSchedualeEdit: _vm.requestSchedualeEdit
              }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e1a9a2d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1a9a2d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/channels/ChannelList.vue
// module id = null
// module chunks = 